// dependencies
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { RouterProvider } from "react-router-dom";

// pages
import router from "./Router";

// styles
import css from "./Main.module.scss";
// utils
import { initSentry } from "./sentry";

initSentry();

const queryClient = new QueryClient();

/**
 * Main component
 * I should probably use a proper router here since the public suite of pages
 * may start getting more complicated.
 */
const Main = () => {
	return (
		<QueryClientProvider client={queryClient}>
			<Sentry.ErrorBoundary fallback={null}>
				<div className={css.main}>
					<RouterProvider router={router} />
				</div>
			</Sentry.ErrorBoundary>
		</QueryClientProvider>
	);
};

export default Main;
